import axios from "axios";
import { Axios, baseUrl } from "../../Services/Axios/index";

export const fetchAreas = async () => {
  return await Axios.get("/admin/laundry-areas/get-areas", {
    responseType: "json",
  });
};
export const addAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.post("/api/admin/customer/address/add", payload, {
    responseType: "json",
    baseURL: baseUrl,
    headers: {
      moduleid: "",
      storeType: "laundry",
      Laundryzoneid: payload.laundryZoneId,
      Zoneid: payload.zoneId,
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.put(
    `/api/admin/customer/address/update/${payload.id}`,
    payload,
    {
      responseType: "json",
      baseURL: baseUrl,
      headers: {
        moduleid: "",
        storeType: "laundry",
        Laundryzoneid: payload.laundryZoneId,
        Zoneid: payload.zoneId,
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const fetchAddresses = async () => {
  const user_id = localStorage.getItem("customerId");
  return await Axios.get(`/admin/customer/address/list/?user_id=${user_id}`, {
    responseType: "json",
  });
};
export const deleteAddress = async (addressId) => {
  return await Axios.post(
    `/admin/customer/address/delete?address_id=${addressId}`,
    {
      _method: "delete",
    },
    { responseType: "json" }
  );
};
